module.exports = __webpack_public_path__ + "img/eeia-logo.9713c3b0.png";